import { EnvironmentProviders, Provider } from '@angular/core';
import { StorageLocationProductRepository } from './repositories/storage-location-product.repository';
import { StorageLocationRepository } from './repositories/storage-location.repository';
import { StorageLocationProductService } from './services/storage-location-product.service';
import { StorageLocationService } from './services/storage-location.service';

// Cross-cutting/module-level providers WITHOUT the routes graph — composed at
// boot both by provideStorageLocation (monolith path) and the remote's
// ./ModuleGlobals entry (federation path). Must not import the routes file.
export function provideStorageLocationGlobals(): Array<Provider | EnvironmentProviders> {
  return [
    StorageLocationProductRepository,
    StorageLocationProductService,
    StorageLocationRepository,
    StorageLocationService,
  ];
}
